import { Box } from "@mui/material";
import { QuantumIcon } from "../Icons";
import { makeStyles } from "@mui/styles";
import { palette } from "../../theme/palette";
import { View } from "../View";

const useStyles = makeStyles(({ typography }) => ({
  header: {
    backgroundColor: palette.black,
    display: "flex",
    height: typography.pxToRem(40),
    boxShadow: `0px 2px 3px rgba(255, 255, 255, 0.1)`,
  },
  content: {
    flexGrow: 1,
    justifyContent: "flex-end",
    display: "flex",
    alignItems: "center",
  },
}));

export const HeaderBar = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.header}>
      <QuantumIcon />
      <View className={classes.content}>{children && [...children]}</View>
    </Box>
  );
};
